import { mechanicDetailApi } from 'widgets/mechanicDetailPage/api/mechanicDetailApi';
import { MechanicType, SkuType } from 'entities/mechanic';
import { toast } from 'react-toastify';
import { HTTP_METHODS } from 'shared/consts';

const getMechanicDetailApi = mechanicDetailApi.injectEndpoints({
  endpoints: (builder) => ({
    getMechanicDetail: builder.query<MechanicType, { app_type: string; id: number }>({
      query: ({ app_type, id }) => ({
        url: `/promo-b2b/${app_type}/promo-b2b/admin/objectives/${id}/`,
      }),
      providesTags: ['MechanicDetail'],
    }),

    removeMechanic: builder.mutation<any, { app_type: string; id: number }>({
      query: ({ app_type, id }) => ({
        url: `/promo-b2b/${app_type}/promo-b2b/admin/objectives/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили механику', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['MechanicDetail'];
      },
    }),
    getAllSkuList: builder.query<{ skus: SkuType[] }, { app_type: string }>({
      query: ({ app_type }) => ({
        url: `/sales/${app_type}/sales/skus/`,
      }),
      providesTags: ['SkuList'],
    }),
    postSKUFile: builder.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file as File);
        return {
          url: `/promo-b2b/admin/promo-b2b/admin/objectives/${id}/skus/`,
          method: HTTP_METHODS.POST,
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно загрузили файл', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'MechanicDetail' }];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetMechanicDetailQuery, useRemoveMechanicMutation, useGetAllSkuListQuery, usePostSKUFileMutation } =
  getMechanicDetailApi;
